import { createReducer, createSelector, on } from "@ngrx/store";
import { loadAppConfigurationSuccess, loadBrandingConfigurationSuccess, setLoadingState } from "./app-configuration.actions";
import { BrandingConfiguration } from "./models/BrandingConfiguration";
import { UserType } from "./models/UserType";

export interface IAppConfigurationState {
    appName: string;
    appVersion: string;
    appDescription: string;
    appEnvironment: string;
    isLoading: boolean;
    configRetrieved: Date | null;
    brandingConfiguration: BrandingConfiguration;
    userType: UserType | null;
}

export const initialAppConfiguration: IAppConfigurationState = {
    appName: "",
    appVersion: "",
    appDescription: "",
    appEnvironment: "",
    configRetrieved: null,
    isLoading: false,
    brandingConfiguration: {},
    userType: null
};

export const appConfigurationReducer = createReducer(
    initialAppConfiguration,
    // Add action handlers here
    on(loadAppConfigurationSuccess, (state, { configuration }) => {
        return {
            ...state,
            ...configuration
        }
    }),
    on(setLoadingState, (state, { isLoading }) => {
        return {
            ...state,
            isLoading
        }
    }),
    on(loadBrandingConfigurationSuccess, (state, { brandingConfiguration }) => {
        return {
            ...state,
            brandingConfiguration
        }
    })
);

export const selectAppConfigurationState = (state: any): IAppConfigurationState => state.AppConfigurationState;

export const selectIsLoading = createSelector(
    selectAppConfigurationState,
    (state) => state.isLoading
);

export const selectBrandingConfiguration = createSelector(
    selectAppConfigurationState,
    (state) => state.brandingConfiguration
);

export const selectUserType = createSelector(
    selectAppConfigurationState,
    (state) => state.userType
);